
import { Component, Vue, Prop } from 'nuxt-property-decorator';
import { ContentDto, JsonSpeakerContentData } from 'fourwaves-shared';

@Component({})
export default class SpeakersContentBlock extends Vue {
  @Prop({ required: true }) content!: ContentDto;
  @Prop({ required: true }) speakers!: JsonSpeakerContentData[];

  public getSpeakerImageUrl(speaker: { fileUploadId: string }): string {
    return `${this.getFileUrl(speaker.fileUploadId)}?w=400&auto=format`;
  }

  public getFileUrl(id: string): string {
    return this.$api.getFileUploadUrl(id);
  }
}
